import { useEffect, useState } from "react";

const Auth = () => {
  const [auth, setAuth] = useState(null);

  useEffect(() => {
    const loggedInUser = sessionStorage.getItem("authenticated");
    setAuth(loggedInUser === "true");
  }, []);

  return auth;
};

export default Auth;